import React, { Component } from "react";
import olMap from "ol/Map";
import olView from "ol/View";
import olTileLayer from "ol/layer/Tile";
import olSourceXYZ from "ol/source/XYZ";
import Overlay from "ol/Overlay";
import { fromLonLat, toLonLat } from 'ol/proj.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import { Style, Text, Fill, Stroke, Circle } from "ol/style.js";
import SearchOverlay from "./SearchOverlay";
import ParcelOverlay from "./ParcelOverlay";
import DrawingOverlay from "./DrawingOverlay";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import VectorTileSource from "ol/source/VectorTile";
import VectorTileLayer from "ol/layer/VectorTile";
import TileArcGISRest from "ol/source/TileArcGISRest";
import GeoJSON from 'ol/format/GeoJSON';
import MVT from 'ol/format/MVT';
import olWKT from "ol/format/WKT";
import axios from 'axios';
import { applyStyle } from 'ol-mapbox-style';
import BasemapSwitcherControl from './BasemapSwitcherControl';
import TileLayer from 'ol/layer/Tile';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import { get as getProjection } from 'ol/proj';
import { getTopLeft, getWidth } from 'ol/extent';
import "./Map.css";

class Map extends Component {
  state = {
    map: {},
    vectorLayer: null,
    mapStyle: {},
    selectedParcels: [],
  };

  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    const { map } = this.state;
    map.updateSize();
  } 

  componentDidMount() {
    const { vectorSource, mapClickHandler, setMapReference } = this.props;



    // Define the VectorTile layer source
    const vectorTileSource = new VectorTileSource({
      format: new MVT(), // MVT format for PBF vector tiles
      url: window.clipship_config.BasemapUrl + '/tile/{z}/{y}/{x}.pbf'
    });


    const styleUrl = window.clipship_config.BasemapUrl + '/resources/styles/root.json';

    // Define the VectorTile layer
    const vectorTileLayer = new VectorTileLayer({
      source: vectorTileSource,
      style: null, // Use default styling; customize this as needed
    });


    const projection = getProjection('EPSG:3857');
    const projectionExtent = projection.getExtent();
    const size = getWidth(projectionExtent) / 256;
    const resolutions = new Array(19);
    const matrixIds = new Array(19);
    for (let z = 0; z < 19; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      matrixIds[z] = z;
    }

    // WMTS Layer source
    const wmtsSource = new WMTS({
      //url: 'https://us0.nearmap.com/maps/api/wmts/v1/apikey/OTQxYjllMzUtZGI2Yy00MGUxLWI2OWItZDg5ODAxNTJiNjg1', // Replace with your WMTS service URL
      url: 'https://gispublicweb.provo.org/arcgis/rest/services/Imagery/2023_Web/MapServer/WMTS',
      layer: 'sgmc2', // The layer name
      matrixSet: 'GoogleMapsCompatible', // Coordinate system
      format: 'image/png', // Tile format
      projection: projection,
      tileGrid: new WMTSTileGrid({
        origin: getTopLeft(projectionExtent),
        resolutions: resolutions,
        matrixIds: matrixIds,
      }),
      style: 'default',
      wrapX: true,
    });

    // Define the TileLayer layer
    const imageryTileLayer = new TileLayer({
      source: wmtsSource,
      visible: false
    });



    const map = new olMap({
      target: this.mapRef.current,
      layers: [vectorTileLayer, imageryTileLayer],
      overlays: [],
      view: new olView({
        center: [-12432215.385302758, 4903222.77518611],
        zoom: 13
      })
    });

    const basemapSwitcher = new BasemapSwitcherControl({
      handler: ()=> {
        vectorTileLayer.setVisible(!vectorTileLayer.getVisible());
        imageryTileLayer.setVisible(!vectorTileLayer.getVisible());
      }
    });
    map.addControl(basemapSwitcher);
    
    applyStyle(vectorTileLayer, styleUrl)
    .then(() => {
      console.log('Style applied to the vector tile layer');
    })
    .catch((err) => {
      console.error('Error applying style: ', err);
    });


    map.on("click", mapClickHandler);

    /*
    const boundarySource = new VectorSource({
      format: new GeoJSON(),
      url: window.clipship_config.CityBoundaryLayerUrl
    });

    boundarySource.on('addfeature', function() {
      map.getView().fit(boundarySource.getExtent());
    });

    const boundaryLayer = new VectorLayer({
      source: boundarySource,
      style: new Style({
        stroke: new Stroke({
          color: 'blue',
          width: 2
        }),
      })
    });

    map.addLayer(boundaryLayer);
    */

    this.setState({
      map: map,
    },()=>setMapReference(map));
  }

  render() {
    const { mapHeight, mapWidth, geometryCreationMode, vectorSource, searchVectorSource, validatedFeature } = this.props;
    const { mapStyle, map, selectedParcels, vectorLayer } = this.state;
    return (
      <>
        <div
          style={mapHeight ? { height: mapHeight } : mapStyle}
          ref={this.mapRef}
        ></div>
        <SearchOverlay map={map} vectorSource={searchVectorSource} />
        <ParcelOverlay map={map} vectorSource={vectorSource} />
        <DrawingOverlay map={map} enabled={geometryCreationMode==='DrawPolygon' && !validatedFeature} vectorSource={vectorSource} vectorLayer={vectorLayer} />
      </>
    );
  }
}

export default Map;

//<img style={{position:'absolute',float:'right'}}src="loading.gif" />